import {StoppageAnalysisPage as StoppageAnalysisFeaturePage} from '@features/stoppage-analysis'
import {useTranslation} from 'react-i18next'
import {useParams} from 'react-router'

type PathParameter = {
  plantId?: string
}

export const StoppageAnalysisPage = () => {
  const {t} = useTranslation()
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('plantId is missing')

  return (
    <StoppageAnalysisFeaturePage plantId={plantId} pageTitle={t('stoppageAnalysis.pageTitle')} />
  )
}
